import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.haven': 'Haven',
    'nav.dashboard': 'Dashboard',
    'nav.patterns': 'Patterns',
    'nav.journal': 'Journal',
    'nav.sound': 'Sound',
    'nav.hrv': 'HRV',
    'nav.eeg': 'EEG',
    'nav.meditate': 'Meditate',
    'nav.milestones': 'Milestones',
    'nav.community': 'Community',
    'nav.settings': 'Settings',
    'nav.logout': 'Log Out',
    'nav.games': 'Games',
    'nav.crystals': 'Crystals',
    'nav.blend': 'Blend',
    'nav.binaural': 'Binaural',
    'nav.cosmic': 'Cosmic',
    'nav.dreams': 'Dreams',
    'nav.score': 'Score',
    'nav.rx': 'Rx',
    'nav.ceremonies': 'Ceremonies',
    'nav.holistic': 'Holistic',
    'nav.help': 'Help',
    // Pages Titles & Subtitles
    'games.title': 'Mind Games',
    'games.subtitle': 'Quick 5-10 minute exercises for focus, memory & calm',
    'ceremonies.title': 'Sacred Ceremonies',
    'ceremonies.subtitle': 'Group meditation rituals and sacred sound experiences',
    'crystals.title': 'Crystal Liberation Protocol',
    'crystals.subtitle': 'Pattern analysis and consciousness transformation',
    'blend.title': 'Crystal Combinations',
    'blend.subtitle': 'Discover powerful crystal synergies and healing blends',
    'cosmic.title': 'Cosmic Alignment',
    'cosmic.subtitle': 'Real-time planetary positions and consciousness guidance',
    'dreams.title': 'Dream Journal',
    'dreams.subtitle': 'Record and analyze your dream patterns',
    'score.title': 'Consciousness Score',
    'score.subtitle': 'Track your awareness evolution over time',
    'rx.title': 'Frequency Prescription',
    'rx.subtitle': 'Personalized healing frequencies based on your state',
    'sound.title': 'Sound Healing',
    'sound.subtitle': 'Sacred frequencies for transformation and healing',
    'holistic.title': 'Holistic Healing',
    'holistic.subtitle': 'Integrated wellness tools and practices',
    'community.title': 'Conscious Community',
    'community.subtitle': 'Connect with others on the healing path',
    'subscription.title': 'Choose Your Path',
    'subscription.subtitle': 'Start with a 30-day free trial, no credit card required',
    // Landing
    'landing.hero': 'Shift from Victim',
    'landing.hero2': 'to Creator Consciousness',
    'landing.subtitle': 'A holistic healing ecosystem powered by real biofeedback, live cosmic data, and AI-driven personalization.',
    'landing.cta': 'Start Your Journey',
    'landing.explore': 'Explore Features',
    'landing.community_cta': 'Join the Conscious Community',
    'landing.community_desc': 'Connect with others on the path of self-responsibility and source awareness.',
    'landing.begin': 'Begin Awareness',
    // Auth
    'auth.login': 'Sign In',
    'auth.register': 'Create Account',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.name': 'Full Name',
    // Dashboard
    'dashboard.greeting': 'Good Day',
    'dashboard.sound_healing': 'Sound Healing',
    'dashboard.patterns': 'Patterns',
    'dashboard.journal': 'Journal',
    'dashboard.hrv_monitor': 'HRV Monitor',
    // HRV
    'hrv.title': 'HRV Monitor',
    'hrv.subtitle': 'Real-time heart rate variability with Bluetooth LE or demo mode',
    'hrv.choose_input': 'Choose Your Input Method',
    'hrv.ble_connect': 'Connect BLE Device',
    'hrv.demo_mode': 'Demo Mode',
    'hrv.heart_rate': 'Heart Rate',
    'hrv.stress': 'Stress',
    'hrv.coherence': 'Coherence',
    'hrv.start': 'Start',
    'hrv.stop': 'Stop',
    'hrv.save': 'Save',
    'hrv.adaptive': 'Adaptive Frequency Therapy',
    // EEG
    'eeg.title': 'EEG Monitor',
    'eeg.subtitle': 'Brainwave visualization with Muse headband or demo mode',
    'eeg.connect_muse': 'Connect Muse',
    'eeg.meditation': 'Meditation',
    'eeg.attention': 'Attention',
    // Meditation
    'meditation.title': 'Meditation Scripts',
    'meditation.subtitle': 'AI-generated scripts personalized to your journey. Record in your own voice.',
    'meditation.generate': 'Generate New Script',
    'meditation.intention': 'Intention (optional)',
    'meditation.record': 'Record',
    'meditation.play': 'Play',
    // Milestones
    'milestones.title': 'Healing Milestones',
    'milestones.subtitle': 'Celebrate and share your consciousness evolution',
    'milestones.share': 'Share Journey',
    'milestones.copy': 'Copy Text',
    // Common
    'common.loading': 'Loading...',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.start': 'Start',
    'common.stop': 'Stop',
    'common.history': 'History',
    'common.monitor': 'Monitor',
    'common.sessions': 'sessions',
    'common.improving': 'Improving',
    'common.declining': 'Declining',
    'common.stable': 'Stable',
    // Dashboard
    'dashboard.enter_haven': 'Enter Haven',
    'dashboard.haven_subtitle': "I'm here. Talk to me and we'll figure this out together.",
    'dashboard.begin_conversation': 'Talk to Haven',
    'dashboard.start_ritual': 'Start Sequence',
    'dashboard.sequence_desc': 'Designed to help regulate your state and refocus your mind.',
    'dashboard.morning_checkin': 'Morning Check-In',
    'dashboard.checkin_time': '90 seconds to tune in',
    'dashboard.sound_healing': 'Sound Healing',
    'dashboard.frequencies': 'Frequencies',
    'dashboard.hrv_monitor': 'HRV Monitor',
    'dashboard.biofeedback': 'Biofeedback',
    'dashboard.patterns': 'Patterns',
    'dashboard.no_patterns': 'No patterns yet',
    'dashboard.nothing_active': 'Nothing active yet',
    'dashboard.tracked': 'tracked',
    'dashboard.journal': 'Journal',
    'dashboard.reflect': 'Reflect',
    'dashboard.crystal_liberation': 'Crystal Liberation',
    'dashboard.matrix_exit': 'Matrix Exit',
    'dashboard.binaural_beats': 'Binaural Beats',
    'dashboard.brainwaves': 'Brainwaves',
    'dashboard.reality_shifts': 'Reality Shifts',
    'dashboard.experiments': 'Experiments',
    'dashboard.active': 'active',
    'dashboard.todays_checkin': "Today's Check-In",
    'dashboard.mood': 'Mood',
    'dashboard.energy': 'Energy',
    'dashboard.intention': 'Intention',
    'dashboard.explore_all_features': 'Explore All Features',
    // Features Page
    'features.title': 'All Features',
    'features.subtitle': 'Your complete toolkit for consciousness transformation',
    'features.back_to_dashboard': 'Back to Dashboard',
    'features.category_ai': 'AI & Intelligence',
    'features.category_sound': 'Sound & Frequency',
    'features.category_biofeedback': 'Biofeedback & Sensors',
    'features.category_tracking': 'Tracking & Journaling',
    'features.category_healing': 'Healing & Wellness',
    'features.category_cosmic': 'Cosmic & Earth Energy',
    'features.category_community': 'Community & Games',
    'features.haven_ai': 'Haven AI',
    'features.haven_ai_desc': 'Your consciousness mirror',
    'features.crystal_liberation': 'Crystal Liberation',
    'features.crystal_liberation_desc': 'Pattern transformation',
    'features.frequency_rx': 'Frequency Rx',
    'features.frequency_rx_desc': 'Personalized prescriptions',
    'features.sound_healing': 'Sound Healing',
    'features.sound_healing_desc': 'Sacred frequencies',
    'features.binaural_beats': 'Binaural Beats',
    'features.binaural_beats_desc': 'Brainwave entrainment',
    'features.crystal_combos': 'Crystal Blends',
    'features.crystal_combos_desc': 'Harmonic synergies',
    'features.hrv_monitor': 'HRV Monitor',
    'features.hrv_monitor_desc': 'Heart coherence tracking',
    'features.eeg_monitor': 'EEG Monitor',
    'features.eeg_monitor_desc': 'Brainwave visualization',
    'features.sensor_hub': 'Sensor Hub',
    'features.sensor_hub_desc': 'Device connections',
    'features.energy_scan': 'Energy Scan',
    'features.energy_scan_desc': 'Biofield analysis',
    'features.patterns': 'Patterns',
    'features.patterns_desc': 'Behavioral awareness',
    'features.journal': 'Journal',
    'features.journal_desc': 'Daily reflections',
    'features.dreams': 'Dream Journal',
    'features.dreams_desc': 'Dream analysis',
    'features.consciousness': 'Consciousness Score',
    'features.consciousness_desc': 'Awareness metrics',
    'features.reality_shifts': 'Reality Shifts',
    'features.reality_shifts_desc': 'Manifestation tracking',
    'features.experiments': 'Experiments',
    'features.experiments_desc': 'Consciousness labs',
    'features.daily_ritual': 'Daily Ritual',
    'features.daily_ritual_desc': 'Guided sequences',
    'features.holistic': 'Holistic Healing',
    'features.holistic_desc': 'Integrated wellness',
    'features.health_tracking': 'Health Tracking',
    'features.health_tracking_desc': 'Vitals dashboard',
    'features.nutrition': 'Nutrition Guide',
    'features.nutrition_desc': 'Conscious eating',
    'features.astrology': 'Cosmic Alignment',
    'features.astrology_desc': 'Planetary positions',
    'features.ley_lines': 'Ley Lines',
    'features.ley_lines_desc': 'Earth grid mapping',
    'features.community': 'Community',
    'features.community_desc': 'Connect with others',
    'features.milestones': 'Milestones',
    'features.milestones_desc': 'Achievement sharing',
    'features.mind_games': 'Mind Games',
    'features.mind_games_desc': 'Focus exercises',
    // Landing Features
    'landing.ecosystem_title': 'The Healing Ecosystem',
    'landing.ecosystem_subtitle': 'Every tool connected. Every data source real. Every insight personalized.',
    'landing.footer': 'NeuroHeal — Consciousness-Based Healing Ecosystem',
    // Feature titles
    'feature.pattern_recognition': 'Pattern Recognition',
    'feature.pattern_desc': 'Identify unconscious behavior loops creating recurring challenges.',
    'feature.haven_ai': 'Haven AI',
    'feature.haven_desc': 'Your consciousness mirror powered by GPT-4o.',
    'feature.hrv_biofeedback': 'HRV Biofeedback',
    'feature.hrv_desc': 'Real-time heart coherence via Bluetooth LE sensors.',
    'feature.sound_healing': 'Sound Healing',
    'feature.sound_desc': 'Solfeggio frequencies and binaural beats for deep healing.',
    'feature.astro_alignment': 'Astro Alignment',
    'feature.astro_desc': 'Real ephemeris data with live NOAA geomagnetic feeds.',
    'feature.crystal_protocol': 'Crystal Protocol',
    'feature.crystal_desc': 'Biofrequency liberation with sacred geometry harmonics.',
    // Auth
    'auth.welcome_back': 'Welcome back, Creator',
    'auth.begin_transformation': 'Begin your transformation',
    'auth.name_label': 'Name',
    'auth.email_label': 'Email',
    'auth.password_label': 'Password',
    'auth.sign_in': 'Sign In',
    'auth.create_account': 'Create Account',
    'auth.no_account': "Don't have an account? Sign up",
    'auth.has_account': 'Already have an account? Sign in',
    'auth.processing': 'Processing...',
    // Haven
    'haven.title': 'Haven',
    'haven.subtitle': 'Your consciousness mirror and awareness guide',
    'haven.welcome': 'Welcome, Creator',
    'haven.welcome_message': "I'm Haven, your consciousness mirror. Share what's on your mind, and let's explore the patterns shaping your reality.",
    'haven.voice_tip': 'Tip: Tap the microphone to speak your thoughts',
    'haven.placeholder': "Share what's on your mind...",
    'haven.voice_enabled': 'Haven Voice',
    'haven.voice_off': 'Voice Off',
    'haven.speaking': 'Speaking...',
    'haven.listening': 'Listening...',
    'haven.conversations': 'Conversations',
    'haven.new_chat': 'New Chat',
    'haven.new_chat_created': 'New chat created',
    'haven.no_conversations': 'No conversations yet',
    'haven.chat_history': 'Chat History',
    'haven.delete_confirm': 'Delete this conversation?',
    'haven.chat_deleted': 'Chat deleted',
    'haven.search_chats': 'Search chats...',
    'haven.no_results': 'No chats found',
    // Binaural
    'binaural.title': 'Binaural Beat Generator',
    'binaural.subtitle': 'Brainwave entrainment personalized to your consciousness score',
    'binaural.headphones': 'Use headphones for optimal effect',
    'binaural.preset_programs': 'Preset Programs',
    'binaural.ai_personalized': 'AI Personalized',
    'binaural.custom_beat': 'Custom Beat',
    'binaural.stop_session': 'Stop Session',
    'binaural.start_program': 'Start Program',
    'binaural.generate_program': 'Generate My Program',
    'binaural.analyzing': 'Analyzing consciousness...',
    'binaural.brainwave_state': 'Brainwave State',
    'binaural.carrier_frequency': 'Carrier Frequency',
    'binaural.duration': 'Duration',
    'binaural.start_custom': 'Start Custom Session',
    'binaural.your_stats': 'Your Stats',
    'binaural.total_sessions': 'Total Sessions',
    'binaural.total_minutes': 'Total Minutes',
    'binaural.brainwave_guide': 'Brainwave Guide',
    'binaural.headphones_required': 'Headphones Required',
    'binaural.headphones_desc': 'Binaural beats require stereo headphones to work. Each ear receives a slightly different frequency, creating the entrainment effect in your brain.',
    // Settings
    'settings.title': 'Settings',
    'settings.profile': 'Profile',
    'settings.subscription': 'Subscription',
    'settings.frequency_sessions': 'Frequency & Sessions',
    'settings.default_frequency': 'Default Frequency (Hz)',
    'settings.session_duration': 'Default Session Duration (min)',
    'settings.preferred_breathwork': 'Preferred Breathwork',
    'settings.preferences': 'Preferences',
    'settings.dark_mode': 'Dark Mode',
    'settings.notifications': 'Notifications',
    'settings.auto_play': 'Auto-Play Sound',
    'settings.lunar_info': 'Show Lunar Info',
    'settings.save_profile': 'Save Profile',
    'settings.save_all': 'Save All Settings',
    'settings.manage_subscription': 'Manage Subscription',
    'settings.subscribe_now': 'Subscribe Now',
    'settings.support': 'Support',
    'settings.support_desc': 'Need help with NeuroHeal? Reach out anytime and we\'ll get back to you as soon as possible.',
    // Help/Support
    'help.title': 'Help & Support',
    'help.subtitle': "We're here to help you on your healing journey",
    'help.contact': 'Contact Support',
    'help.contact_desc': 'Get help from our team',
    'help.email_desc': 'Have a question, feedback, or issue? Email us anytime and we\'ll respond as quickly as possible.',
    'help.quick_links': 'Quick Links',
    'help.account_settings': 'Account & Settings',
    'help.subscription_billing': 'Subscription & Billing',
    'help.ask_haven': 'Ask Haven AI',
    'help.faq': 'Frequently Asked Questions',
    'help.response_time': 'Typical response time: within 24-48 hours',
    // Status
    'status.active': 'Active',
    'status.trial': 'Trial',
    'status.expired': 'Expired',
    'status.loading': 'Loading...',
    'status.days_left': 'days left',
  },
  es: {
    'nav.home': 'Inicio', 'nav.haven': 'Refugio', 'nav.dashboard': 'Panel',
    'nav.patterns': 'Patrones', 'nav.journal': 'Diario', 'nav.sound': 'Sonido',
    'nav.hrv': 'VFC', 'nav.eeg': 'EEG', 'nav.meditate': 'Meditar',
    'nav.milestones': 'Logros', 'nav.community': 'Comunidad',
    'nav.settings': 'Ajustes', 'nav.logout': 'Cerrar Sesión',
    'nav.games': 'Juegos', 'nav.crystals': 'Cristales', 'nav.blend': 'Mezcla',
    'nav.binaural': 'Binaural', 'nav.cosmic': 'Cósmico', 'nav.dreams': 'Sueños',
    'nav.score': 'Puntaje', 'nav.rx': 'Rx', 'nav.ceremonies': 'Ceremonias',
    'nav.holistic': 'Holístico', 'nav.help': 'Ayuda',
    'games.title': 'Juegos Mentales', 'games.subtitle': 'Ejercicios de 5-10 minutos para enfoque, memoria y calma',
    'ceremonies.title': 'Ceremonias Sagradas', 'ceremonies.subtitle': 'Rituales de meditación grupal y sonidos sagrados',
    'crystals.title': 'Protocolo de Liberación Cristal', 'crystals.subtitle': 'Análisis de patrones y transformación de conciencia',
    'blend.title': 'Combinaciones de Cristales', 'blend.subtitle': 'Descubre sinergias poderosas y mezclas curativas',
    'cosmic.title': 'Alineación Cósmica', 'cosmic.subtitle': 'Posiciones planetarias en tiempo real y guía de conciencia',
    'dreams.title': 'Diario de Sueños', 'dreams.subtitle': 'Registra y analiza tus patrones de sueños',
    'score.title': 'Puntuación de Conciencia', 'score.subtitle': 'Rastrea tu evolución de conciencia',
    'rx.title': 'Prescripción de Frecuencia', 'rx.subtitle': 'Frecuencias curativas personalizadas según tu estado',
    'sound.title': 'Sanación Sonora', 'sound.subtitle': 'Frecuencias sagradas para transformación y sanación',
    'holistic.title': 'Sanación Holística', 'holistic.subtitle': 'Herramientas y prácticas de bienestar integradas',
    'community.title': 'Comunidad Consciente', 'community.subtitle': 'Conéctate con otros en el camino de sanación',
    'subscription.title': 'Elige Tu Camino', 'subscription.subtitle': 'Comienza con 30 días gratis, sin tarjeta requerida',
    'landing.hero': 'Cambia de Víctima', 'landing.hero2': 'a Conciencia Creadora',
    'landing.subtitle': 'Un ecosistema de sanación holística impulsado por biofeedback real, datos cósmicos en vivo y personalización por IA.',
    'landing.cta': 'Comienza Tu Viaje', 'landing.explore': 'Explorar Funciones',
    'landing.community_cta': 'Únete a la Comunidad Consciente',
    'landing.community_desc': 'Conéctate con otros en el camino de la auto-responsabilidad y la conciencia de fuente.',
    'landing.begin': 'Comenzar Conciencia',
    'auth.login': 'Iniciar Sesión', 'auth.register': 'Crear Cuenta',
    'auth.email': 'Correo', 'auth.password': 'Contraseña', 'auth.name': 'Nombre Completo',
    'dashboard.greeting': 'Buen día',
    'dashboard.sound_healing': 'Sanación Sonora', 'dashboard.patterns': 'Patrones',
    'dashboard.journal': 'Diario', 'dashboard.hrv_monitor': 'Monitor VFC',
    'hrv.title': 'Monitor VFC', 'hrv.subtitle': 'Variabilidad de frecuencia cardíaca en tiempo real',
    'hrv.choose_input': 'Elige Tu Método', 'hrv.ble_connect': 'Conectar Dispositivo BLE',
    'hrv.demo_mode': 'Modo Demo', 'hrv.heart_rate': 'Frecuencia Cardíaca',
    'hrv.stress': 'Estrés', 'hrv.coherence': 'Coherencia', 'hrv.start': 'Iniciar', 'hrv.stop': 'Detener', 'hrv.save': 'Guardar',
    'hrv.adaptive': 'Terapia de Frecuencia Adaptativa',
    'eeg.title': 'Monitor EEG', 'eeg.subtitle': 'Visualización de ondas cerebrales',
    'eeg.connect_muse': 'Conectar Muse', 'eeg.meditation': 'Meditación', 'eeg.attention': 'Atención',
    'meditation.title': 'Guiones de Meditación', 'meditation.subtitle': 'Guiones generados por IA. Graba con tu propia voz.',
    'meditation.generate': 'Generar Nuevo Guión', 'meditation.intention': 'Intención (opcional)',
    'meditation.record': 'Grabar', 'meditation.play': 'Reproducir',
    'milestones.title': 'Logros de Sanación', 'milestones.subtitle': 'Celebra y comparte tu evolución',
    'milestones.share': 'Compartir Viaje', 'milestones.copy': 'Copiar Texto',
    'common.loading': 'Cargando...', 'common.save': 'Guardar', 'common.cancel': 'Cancelar',
    'common.start': 'Iniciar', 'common.stop': 'Detener', 'common.history': 'Historial',
    'common.monitor': 'Monitor', 'common.sessions': 'sesiones',
    'common.improving': 'Mejorando', 'common.declining': 'Declinando', 'common.stable': 'Estable',
    'dashboard.enter_haven': 'Entrar al Refugio',
    'dashboard.haven_subtitle': 'Estoy aquí. Habla conmigo y lo resolveremos juntos.',
    'dashboard.begin_conversation': 'Hablar con Haven',
    'dashboard.start_ritual': 'Iniciar Secuencia',
    'dashboard.sequence_desc': 'Diseñado para ayudarte a regular tu estado y reenfocar tu mente.',
    'dashboard.morning_checkin': 'Registro Matutino',
    'dashboard.checkin_time': '90 segundos para sintonizar',
    'dashboard.sound_healing': 'Sanación Sonora',
    'dashboard.frequencies': 'Frecuencias',
    'dashboard.hrv_monitor': 'Monitor VFC',
    'dashboard.biofeedback': 'Biofeedback',
    'dashboard.patterns': 'Patrones',
    'dashboard.no_patterns': 'Sin patrones aún',
    'dashboard.nothing_active': 'Nada activo aún',
    'dashboard.tracked': 'rastreados',
    'dashboard.journal': 'Diario',
    'dashboard.reflect': 'Reflexionar',
    'dashboard.crystal_liberation': 'Liberación Cristal',
    'dashboard.matrix_exit': 'Salida Matrix',
    'dashboard.binaural_beats': 'Beats Binaurales',
    'dashboard.brainwaves': 'Ondas Cerebrales',
    'dashboard.reality_shifts': 'Cambios de Realidad',
    'dashboard.experiments': 'Experimentos',
    'dashboard.active': 'activos',
    'dashboard.todays_checkin': 'Registro de Hoy',
    'dashboard.mood': 'Ánimo',
    'dashboard.energy': 'Energía',
    'dashboard.intention': 'Intención',
    'dashboard.explore_all_features': 'Explorar Todas las Funciones',
    'features.title': 'Todas las Funciones',
    'features.subtitle': 'Tu kit completo para la transformación de conciencia',
    'features.back_to_dashboard': 'Volver al Panel',
    'features.category_ai': 'IA e Inteligencia',
    'features.category_sound': 'Sonido y Frecuencia',
    'features.category_biofeedback': 'Biofeedback y Sensores',
    'features.category_tracking': 'Seguimiento y Diario',
    'features.category_healing': 'Sanación y Bienestar',
    'features.category_cosmic': 'Energía Cósmica y Terrestre',
    'features.category_community': 'Comunidad y Juegos',
    'features.haven_ai': 'Haven IA', 'features.haven_ai_desc': 'Tu espejo de conciencia',
    'features.crystal_liberation': 'Liberación Cristal', 'features.crystal_liberation_desc': 'Transformación de patrones',
    'features.frequency_rx': 'Frecuencia Rx', 'features.frequency_rx_desc': 'Prescripciones personalizadas',
    'features.sound_healing': 'Sanación Sonora', 'features.sound_healing_desc': 'Frecuencias sagradas',
    'features.binaural_beats': 'Beats Binaurales', 'features.binaural_beats_desc': 'Ondas cerebrales',
    'features.crystal_combos': 'Mezclas Cristal', 'features.crystal_combos_desc': 'Sinergias armónicas',
    'features.hrv_monitor': 'Monitor VFC', 'features.hrv_monitor_desc': 'Coherencia cardíaca',
    'features.eeg_monitor': 'Monitor EEG', 'features.eeg_monitor_desc': 'Ondas cerebrales',
    'features.sensor_hub': 'Hub de Sensores', 'features.sensor_hub_desc': 'Conexiones de dispositivos',
    'features.energy_scan': 'Escaneo Energético', 'features.energy_scan_desc': 'Análisis de biocampo',
    'features.patterns': 'Patrones', 'features.patterns_desc': 'Conciencia conductual',
    'features.journal': 'Diario', 'features.journal_desc': 'Reflexiones diarias',
    'features.dreams': 'Diario de Sueños', 'features.dreams_desc': 'Análisis de sueños',
    'features.consciousness': 'Puntuación de Conciencia', 'features.consciousness_desc': 'Métricas de conciencia',
    'features.reality_shifts': 'Cambios de Realidad', 'features.reality_shifts_desc': 'Seguimiento de manifestación',
    'features.experiments': 'Experimentos', 'features.experiments_desc': 'Laboratorios de conciencia',
    'features.daily_ritual': 'Ritual Diario', 'features.daily_ritual_desc': 'Secuencias guiadas',
    'features.holistic': 'Sanación Holística', 'features.holistic_desc': 'Bienestar integrado',
    'features.health_tracking': 'Seguimiento de Salud', 'features.health_tracking_desc': 'Panel de vitales',
    'features.nutrition': 'Guía Nutricional', 'features.nutrition_desc': 'Alimentación consciente',
    'features.astrology': 'Alineación Cósmica', 'features.astrology_desc': 'Posiciones planetarias',
    'features.ley_lines': 'Líneas Ley', 'features.ley_lines_desc': 'Mapeo de rejilla terrestre',
    'features.community': 'Comunidad', 'features.community_desc': 'Conecta con otros',
    'features.milestones': 'Logros', 'features.milestones_desc': 'Compartir logros',
    'features.mind_games': 'Juegos Mentales', 'features.mind_games_desc': 'Ejercicios de enfoque',
    'landing.ecosystem_title': 'El Ecosistema de Sanación',
    'landing.ecosystem_subtitle': 'Cada herramienta conectada. Cada fuente de datos real. Cada insight personalizado.',
    'landing.footer': 'NeuroHeal — Ecosistema de Sanación Basado en Conciencia',
    'feature.pattern_recognition': 'Reconocimiento de Patrones',
    'feature.pattern_desc': 'Identifica bucles de comportamiento inconsciente que crean desafíos recurrentes.',
    'feature.haven_ai': 'Haven IA',
    'feature.haven_desc': 'Tu espejo de conciencia impulsado por GPT-4o.',
    'feature.hrv_biofeedback': 'Biofeedback VFC',
    'feature.hrv_desc': 'Coherencia cardíaca en tiempo real vía sensores Bluetooth LE.',
    'feature.sound_healing': 'Sanación Sonora',
    'feature.sound_desc': 'Frecuencias Solfeggio y beats binaurales para sanación profunda.',
    'feature.astro_alignment': 'Alineación Astral',
    'feature.astro_desc': 'Datos de efemérides reales con feeds geomagnéticos NOAA.',
    'feature.crystal_protocol': 'Protocolo Cristal',
    'feature.crystal_desc': 'Liberación de biofrecuencia con armónicos de geometría sagrada.',
    'auth.welcome_back': 'Bienvenido de nuevo, Creador',
    'auth.begin_transformation': 'Comienza tu transformación',
    'auth.name_label': 'Nombre',
    'auth.email_label': 'Correo',
    'auth.password_label': 'Contraseña',
    'auth.sign_in': 'Iniciar Sesión',
    'auth.create_account': 'Crear Cuenta',
    'auth.no_account': '¿No tienes cuenta? Regístrate',
    'auth.has_account': '¿Ya tienes cuenta? Inicia sesión',
    'auth.processing': 'Procesando...',
    'haven.title': 'Refugio',
    'haven.subtitle': 'Tu espejo de conciencia y guía de awareness',
    'haven.welcome': 'Bienvenido, Creador',
    'haven.welcome_message': 'Soy Haven, tu espejo de conciencia. Comparte lo que tienes en mente y exploremos los patrones que dan forma a tu realidad.',
    'haven.voice_tip': 'Consejo: Toca el micrófono para hablar',
    'haven.placeholder': 'Comparte lo que tienes en mente...',
    'haven.voice_enabled': 'Voz de Haven',
    'haven.voice_off': 'Voz Apagada',
    'haven.speaking': 'Hablando...',
    'haven.listening': 'Escuchando...',
    'binaural.title': 'Generador de Beats Binaurales',
    'binaural.subtitle': 'Sincronización cerebral personalizada según tu puntuación de conciencia',
    'binaural.headphones': 'Usa audífonos para un efecto óptimo',
    'binaural.preset_programs': 'Programas Predefinidos',
    'binaural.ai_personalized': 'Personalizado por IA',
    'binaural.custom_beat': 'Beat Personalizado',
    'binaural.stop_session': 'Detener Sesión',
    'binaural.start_program': 'Iniciar Programa',
    'binaural.generate_program': 'Generar Mi Programa',
    'binaural.analyzing': 'Analizando conciencia...',
    'binaural.brainwave_state': 'Estado de Ondas Cerebrales',
    'binaural.carrier_frequency': 'Frecuencia Portadora',
    'binaural.duration': 'Duración',
    'binaural.start_custom': 'Iniciar Sesión Personalizada',
    'binaural.your_stats': 'Tus Estadísticas',
    'binaural.total_sessions': 'Sesiones Totales',
    'binaural.total_minutes': 'Minutos Totales',
    'binaural.brainwave_guide': 'Guía de Ondas Cerebrales',
    'binaural.headphones_required': 'Audífonos Requeridos',
    'binaural.headphones_desc': 'Los beats binaurales requieren audífonos estéreo para funcionar. Cada oído recibe una frecuencia ligeramente diferente, creando el efecto de sincronización en tu cerebro.',
    'settings.title': 'Configuración',
    'settings.profile': 'Perfil',
    'settings.subscription': 'Suscripción',
    'settings.frequency_sessions': 'Frecuencia y Sesiones',
    'settings.default_frequency': 'Frecuencia Predeterminada (Hz)',
    'settings.session_duration': 'Duración de Sesión (min)',
    'settings.preferred_breathwork': 'Respiración Preferida',
    'settings.preferences': 'Preferencias',
    'settings.dark_mode': 'Modo Oscuro',
    'settings.notifications': 'Notificaciones',
    'settings.auto_play': 'Auto-Reproducir Sonido',
    'settings.lunar_info': 'Mostrar Info Lunar',
    'settings.save_profile': 'Guardar Perfil',
    'settings.save_all': 'Guardar Configuración',
    'settings.manage_subscription': 'Administrar Suscripción',
    'settings.subscribe_now': 'Suscribirse Ahora',
    'settings.support': 'Soporte',
    'settings.support_desc': '¿Necesitas ayuda con NeuroHeal? Contáctanos y te responderemos lo antes posible.',
    'help.title': 'Ayuda y Soporte',
    'help.subtitle': 'Estamos aquí para ayudarte en tu viaje de sanación',
    'help.contact': 'Contactar Soporte',
    'help.contact_desc': 'Obtén ayuda de nuestro equipo',
    'help.email_desc': '¿Tienes una pregunta, comentario o problema? Escríbenos y responderemos lo antes posible.',
    'help.quick_links': 'Enlaces Rápidos',
    'help.account_settings': 'Cuenta y Configuración',
    'help.subscription_billing': 'Suscripción y Facturación',
    'help.ask_haven': 'Pregunta a Haven IA',
    'help.faq': 'Preguntas Frecuentes',
    'help.response_time': 'Tiempo de respuesta típico: 24-48 horas',
    'status.active': 'Activo',
    'status.trial': 'Prueba',
    'status.expired': 'Expirado',
    'status.loading': 'Cargando...',
    'status.days_left': 'días restantes',
  },
  fr: {
    'nav.home': 'Accueil', 'nav.haven': 'Havre', 'nav.dashboard': 'Tableau',
    'nav.patterns': 'Schémas', 'nav.journal': 'Journal', 'nav.sound': 'Son',
    'nav.hrv': 'VFC', 'nav.eeg': 'EEG', 'nav.meditate': 'Méditer',
    'nav.milestones': 'Jalons', 'nav.community': 'Communauté',
    'nav.settings': 'Paramètres', 'nav.logout': 'Déconnexion',
    'nav.games': 'Jeux', 'nav.crystals': 'Cristaux', 'nav.blend': 'Mélange',
    'nav.binaural': 'Binaural', 'nav.cosmic': 'Cosmique', 'nav.dreams': 'Rêves',
    'nav.score': 'Score', 'nav.rx': 'Rx', 'nav.ceremonies': 'Cérémonies',
    'nav.holistic': 'Holistique', 'nav.help': 'Aide',
    'games.title': 'Jeux Mentaux', 'games.subtitle': 'Exercices de 5-10 minutes pour la concentration, mémoire et calme',
    'ceremonies.title': 'Cérémonies Sacrées', 'ceremonies.subtitle': 'Rituels de méditation en groupe et sons sacrés',
    'crystals.title': 'Protocole Libération Cristal', 'crystals.subtitle': 'Analyse de schémas et transformation de conscience',
    'blend.title': 'Combinaisons de Cristaux', 'blend.subtitle': 'Découvrez les synergies et mélanges de guérison',
    'cosmic.title': 'Alignement Cosmique', 'cosmic.subtitle': 'Positions planétaires en temps réel et guidance',
    'dreams.title': 'Journal des Rêves', 'dreams.subtitle': 'Enregistrez et analysez vos schémas de rêves',
    'score.title': 'Score de Conscience', 'score.subtitle': 'Suivez votre évolution de conscience',
    'rx.title': 'Prescription de Fréquence', 'rx.subtitle': 'Fréquences de guérison personnalisées',
    'sound.title': 'Guérison Sonore', 'sound.subtitle': 'Fréquences sacrées pour transformation et guérison',
    'holistic.title': 'Guérison Holistique', 'holistic.subtitle': 'Outils et pratiques de bien-être intégrés',
    'community.title': 'Communauté Consciente', 'community.subtitle': 'Connectez-vous avec d\'autres sur le chemin',
    'subscription.title': 'Choisissez Votre Chemin', 'subscription.subtitle': '30 jours gratuits, sans carte de crédit',
    'landing.hero': 'Passez de Victime', 'landing.hero2': 'à Conscience Créatrice',
    'landing.subtitle': 'Un écosystème de guérison holistique alimenté par le biofeedback réel et la personnalisation par IA.',
    'landing.cta': 'Commencez Votre Voyage', 'landing.explore': 'Explorer',
    'landing.community_cta': 'Rejoignez la Communauté Consciente',
    'landing.community_desc': 'Connectez-vous avec d\'autres sur le chemin de la responsabilité personnelle.',
    'landing.begin': 'Commencer',
    'auth.login': 'Connexion', 'auth.register': 'Créer un Compte',
    'auth.email': 'Email', 'auth.password': 'Mot de passe', 'auth.name': 'Nom Complet',
    'dashboard.greeting': 'Bonjour',
    'dashboard.sound_healing': 'Guérison Sonore', 'dashboard.patterns': 'Schémas',
    'dashboard.journal': 'Journal', 'dashboard.hrv_monitor': 'Moniteur VFC',
    'hrv.title': 'Moniteur VFC', 'hrv.subtitle': 'Variabilité cardiaque en temps réel',
    'hrv.choose_input': 'Choisissez Votre Méthode', 'hrv.ble_connect': 'Connecter BLE',
    'hrv.demo_mode': 'Mode Démo', 'hrv.heart_rate': 'Rythme Cardiaque',
    'hrv.stress': 'Stress', 'hrv.coherence': 'Cohérence', 'hrv.start': 'Démarrer', 'hrv.stop': 'Arrêter', 'hrv.save': 'Sauver',
    'hrv.adaptive': 'Thérapie Fréquentielle Adaptative',
    'eeg.title': 'Moniteur EEG', 'eeg.subtitle': 'Visualisation des ondes cérébrales',
    'eeg.connect_muse': 'Connecter Muse', 'eeg.meditation': 'Méditation', 'eeg.attention': 'Attention',
    'meditation.title': 'Scripts de Méditation', 'meditation.subtitle': 'Scripts IA personnalisés. Enregistrez avec votre voix.',
    'meditation.generate': 'Générer un Nouveau Script', 'meditation.intention': 'Intention (optionnel)',
    'meditation.record': 'Enregistrer', 'meditation.play': 'Lecture',
    'milestones.title': 'Jalons de Guérison', 'milestones.subtitle': 'Célébrez votre évolution',
    'milestones.share': 'Partager le Voyage', 'milestones.copy': 'Copier le Texte',
    'common.loading': 'Chargement...', 'common.save': 'Sauver', 'common.cancel': 'Annuler',
    'common.start': 'Démarrer', 'common.stop': 'Arrêter', 'common.history': 'Historique',
    'common.monitor': 'Moniteur', 'common.sessions': 'séances',
    'common.improving': 'En amélioration', 'common.declining': 'En baisse', 'common.stable': 'Stable',
    'dashboard.enter_haven': 'Entrer dans le Havre',
    'dashboard.haven_subtitle': 'Je suis là. Parle-moi et nous trouverons une solution ensemble.',
    'dashboard.begin_conversation': 'Parler à Haven',
    'dashboard.start_ritual': 'Démarrer la Séquence',
    'dashboard.sequence_desc': 'Conçu pour vous aider à réguler votre état et recentrer votre esprit.',
    'dashboard.morning_checkin': 'Bilan Matinal',
    'dashboard.checkin_time': '90 secondes pour se connecter',
    'dashboard.sound_healing': 'Guérison Sonore',
    'dashboard.frequencies': 'Fréquences',
    'dashboard.hrv_monitor': 'Moniteur VFC',
    'dashboard.biofeedback': 'Biofeedback',
    'dashboard.patterns': 'Schémas',
    'dashboard.no_patterns': 'Aucun schéma encore',
    'dashboard.nothing_active': 'Rien d\'actif encore',
    'dashboard.tracked': 'suivis',
    'dashboard.journal': 'Journal',
    'dashboard.reflect': 'Réfléchir',
    'dashboard.crystal_liberation': 'Libération Cristal',
    'dashboard.matrix_exit': 'Sortie Matrice',
    'dashboard.binaural_beats': 'Battements Binauraux',
    'dashboard.brainwaves': 'Ondes Cérébrales',
    'dashboard.reality_shifts': 'Changements de Réalité',
    'dashboard.experiments': 'Expériences',
    'dashboard.active': 'actives',
    'dashboard.todays_checkin': "Bilan d'Aujourd'hui",
    'dashboard.mood': 'Humeur',
    'dashboard.energy': 'Énergie',
    'dashboard.intention': 'Intention',
    'dashboard.explore_all_features': 'Explorer Toutes les Fonctions',
    'features.title': 'Toutes les Fonctions',
    'features.subtitle': 'Votre boîte à outils complète pour la transformation de conscience',
    'features.back_to_dashboard': 'Retour au Tableau de Bord',
    'features.category_ai': 'IA et Intelligence',
    'features.category_sound': 'Son et Fréquence',
    'features.category_biofeedback': 'Biofeedback et Capteurs',
    'features.category_tracking': 'Suivi et Journal',
    'features.category_healing': 'Guérison et Bien-être',
    'features.category_cosmic': 'Énergie Cosmique et Terrestre',
    'features.category_community': 'Communauté et Jeux',
    'features.haven_ai': 'Haven IA', 'features.haven_ai_desc': 'Votre miroir de conscience',
    'features.crystal_liberation': 'Libération Cristal', 'features.crystal_liberation_desc': 'Transformation de schémas',
    'features.frequency_rx': 'Fréquence Rx', 'features.frequency_rx_desc': 'Prescriptions personnalisées',
    'features.sound_healing': 'Guérison Sonore', 'features.sound_healing_desc': 'Fréquences sacrées',
    'features.binaural_beats': 'Battements Binauraux', 'features.binaural_beats_desc': 'Ondes cérébrales',
    'features.crystal_combos': 'Mélanges Cristal', 'features.crystal_combos_desc': 'Synergies harmoniques',
    'features.hrv_monitor': 'Moniteur VFC', 'features.hrv_monitor_desc': 'Cohérence cardiaque',
    'features.eeg_monitor': 'Moniteur EEG', 'features.eeg_monitor_desc': 'Ondes cérébrales',
    'features.sensor_hub': 'Hub de Capteurs', 'features.sensor_hub_desc': 'Connexions d\'appareils',
    'features.energy_scan': 'Scan Énergétique', 'features.energy_scan_desc': 'Analyse de biochamp',
    'features.patterns': 'Schémas', 'features.patterns_desc': 'Conscience comportementale',
    'features.journal': 'Journal', 'features.journal_desc': 'Réflexions quotidiennes',
    'features.dreams': 'Journal de Rêves', 'features.dreams_desc': 'Analyse des rêves',
    'features.consciousness': 'Score de Conscience', 'features.consciousness_desc': 'Métriques de conscience',
    'features.reality_shifts': 'Changements de Réalité', 'features.reality_shifts_desc': 'Suivi de manifestation',
    'features.experiments': 'Expériences', 'features.experiments_desc': 'Laboratoires de conscience',
    'features.daily_ritual': 'Rituel Quotidien', 'features.daily_ritual_desc': 'Séquences guidées',
    'features.holistic': 'Guérison Holistique', 'features.holistic_desc': 'Bien-être intégré',
    'features.health_tracking': 'Suivi de Santé', 'features.health_tracking_desc': 'Tableau de bord vital',
    'features.nutrition': 'Guide Nutritionnel', 'features.nutrition_desc': 'Alimentation consciente',
    'features.astrology': 'Alignement Cosmique', 'features.astrology_desc': 'Positions planétaires',
    'features.ley_lines': 'Lignes de Ley', 'features.ley_lines_desc': 'Cartographie de grille terrestre',
    'features.community': 'Communauté', 'features.community_desc': 'Connectez-vous aux autres',
    'features.milestones': 'Jalons', 'features.milestones_desc': 'Partage de réalisations',
    'features.mind_games': 'Jeux Mentaux', 'features.mind_games_desc': 'Exercices de concentration',
    'landing.ecosystem_title': "L'Écosystème de Guérison",
    'landing.ecosystem_subtitle': 'Chaque outil connecté. Chaque source de données réelle. Chaque insight personnalisé.',
    'landing.footer': 'NeuroHeal — Écosystème de Guérison Basé sur la Conscience',
    'feature.pattern_recognition': 'Reconnaissance de Schémas',
    'feature.pattern_desc': 'Identifiez les boucles de comportement inconscient créant des défis récurrents.',
    'feature.haven_ai': 'Haven IA',
    'feature.haven_desc': 'Votre miroir de conscience alimenté par GPT-4o.',
    'feature.hrv_biofeedback': 'Biofeedback VFC',
    'feature.hrv_desc': 'Cohérence cardiaque en temps réel via capteurs Bluetooth LE.',
    'feature.sound_healing': 'Guérison Sonore',
    'feature.sound_desc': 'Fréquences Solfeggio et battements binauraux pour une guérison profonde.',
    'feature.astro_alignment': 'Alignement Astral',
    'feature.astro_desc': 'Données éphémérides réelles avec flux géomagnétiques NOAA.',
    'feature.crystal_protocol': 'Protocole Cristal',
    'feature.crystal_desc': 'Libération de biofréquence avec harmoniques de géométrie sacrée.',
    'auth.welcome_back': 'Bienvenue, Créateur',
    'auth.begin_transformation': 'Commencez votre transformation',
    'auth.name_label': 'Nom',
    'auth.email_label': 'Email',
    'auth.password_label': 'Mot de passe',
    'auth.sign_in': 'Connexion',
    'auth.create_account': 'Créer un Compte',
    'auth.no_account': "Pas de compte? Inscrivez-vous",
    'auth.has_account': 'Déjà un compte? Connectez-vous',
    'auth.processing': 'Traitement...',
    'haven.title': 'Havre',
    'haven.subtitle': 'Votre miroir de conscience et guide de conscience',
    'haven.welcome': 'Bienvenue, Créateur',
    'haven.welcome_message': "Je suis Haven, votre miroir de conscience. Partagez ce qui vous préoccupe et explorons les schémas qui façonnent votre réalité.",
    'haven.voice_tip': 'Conseil: Appuyez sur le micro pour parler',
    'haven.placeholder': 'Partagez ce qui vous préoccupe...',
    'haven.voice_enabled': 'Voix de Haven',
    'haven.voice_off': 'Voix Désactivée',
    'haven.speaking': 'Parle...',
    'haven.listening': 'Écoute...',
    'binaural.title': 'Générateur de Battements Binauraux',
    'binaural.subtitle': 'Entraînement cérébral personnalisé selon votre score de conscience',
    'binaural.headphones': 'Utilisez des écouteurs pour un effet optimal',
    'binaural.preset_programs': 'Programmes Prédéfinis',
    'binaural.ai_personalized': 'Personnalisé par IA',
    'binaural.custom_beat': 'Battement Personnalisé',
    'binaural.stop_session': 'Arrêter la Séance',
    'binaural.start_program': 'Démarrer le Programme',
    'binaural.generate_program': 'Générer Mon Programme',
    'binaural.analyzing': 'Analyse de la conscience...',
    'binaural.brainwave_state': "État d'Onde Cérébrale",
    'binaural.carrier_frequency': 'Fréquence Porteuse',
    'binaural.duration': 'Durée',
    'binaural.start_custom': 'Démarrer Session Personnalisée',
    'binaural.your_stats': 'Vos Statistiques',
    'binaural.total_sessions': 'Sessions Totales',
    'binaural.total_minutes': 'Minutes Totales',
    'binaural.brainwave_guide': "Guide d'Ondes Cérébrales",
    'binaural.headphones_required': 'Écouteurs Requis',
    'binaural.headphones_desc': "Les battements binauraux nécessitent des écouteurs stéréo. Chaque oreille reçoit une fréquence légèrement différente, créant l'effet d'entraînement dans votre cerveau.",
    'settings.title': 'Paramètres',
    'settings.profile': 'Profil',
    'settings.subscription': 'Abonnement',
    'settings.frequency_sessions': 'Fréquence et Sessions',
    'settings.default_frequency': 'Fréquence par Défaut (Hz)',
    'settings.session_duration': 'Durée de Session (min)',
    'settings.preferred_breathwork': 'Respiration Préférée',
    'settings.preferences': 'Préférences',
    'settings.dark_mode': 'Mode Sombre',
    'settings.notifications': 'Notifications',
    'settings.auto_play': 'Lecture Auto du Son',
    'settings.lunar_info': 'Afficher Info Lunaire',
    'settings.save_profile': 'Sauver le Profil',
    'settings.save_all': 'Sauver les Paramètres',
    'settings.manage_subscription': "Gérer l'Abonnement",
    'settings.subscribe_now': "S'abonner",
    'settings.support': 'Support',
    'settings.support_desc': "Besoin d'aide avec NeuroHeal? Contactez-nous et nous vous répondrons rapidement.",
    'help.title': 'Aide et Support',
    'help.subtitle': 'Nous sommes là pour vous aider dans votre parcours de guérison',
    'help.contact': 'Contacter le Support',
    'help.contact_desc': "Obtenez l'aide de notre équipe",
    'help.email_desc': "Question, commentaire ou problème? Écrivez-nous et nous répondrons rapidement.",
    'help.quick_links': 'Liens Rapides',
    'help.account_settings': 'Compte et Paramètres',
    'help.subscription_billing': 'Abonnement et Facturation',
    'help.ask_haven': 'Demander à Haven IA',
    'help.faq': 'Questions Fréquentes',
    'help.response_time': 'Temps de réponse typique: 24-48 heures',
    'status.active': 'Actif',
    'status.trial': 'Essai',
    'status.expired': 'Expiré',
    'status.loading': 'Chargement...',
    'status.days_left': 'jours restants',
  },
  de: {
    'nav.home': 'Start', 'nav.haven': 'Zuflucht', 'nav.dashboard': 'Übersicht',
    'nav.patterns': 'Muster', 'nav.journal': 'Tagebuch', 'nav.sound': 'Klang',
    'nav.hrv': 'HRV', 'nav.eeg': 'EEG', 'nav.meditate': 'Meditieren',
    'nav.milestones': 'Meilensteine', 'nav.community': 'Gemeinschaft',
    'nav.settings': 'Einstellungen', 'nav.logout': 'Abmelden',
    'nav.games': 'Spiele', 'nav.crystals': 'Kristalle', 'nav.blend': 'Mischung',
    'nav.binaural': 'Binaural', 'nav.cosmic': 'Kosmisch', 'nav.dreams': 'Träume',
    'nav.score': 'Punktzahl', 'nav.rx': 'Rx', 'nav.ceremonies': 'Zeremonien',
    'nav.holistic': 'Ganzheitlich', 'nav.help': 'Hilfe',
    'games.title': 'Geistes-Spiele', 'games.subtitle': '5-10 Minuten Übungen für Fokus, Gedächtnis und Ruhe',
    'ceremonies.title': 'Heilige Zeremonien', 'ceremonies.subtitle': 'Gruppen-Meditationsrituale und heilige Klänge',
    'crystals.title': 'Kristall-Befreiungsprotokoll', 'crystals.subtitle': 'Musteranalyse und Bewusstseins-Transformation',
    'blend.title': 'Kristall-Kombinationen', 'blend.subtitle': 'Entdecke kraftvolle Synergien und Heilmischungen',
    'cosmic.title': 'Kosmische Ausrichtung', 'cosmic.subtitle': 'Echtzeit-Planetenpositionen und Bewusstseinsführung',
    'dreams.title': 'Traumtagebuch', 'dreams.subtitle': 'Aufzeichnen und analysieren deiner Traummuster',
    'score.title': 'Bewusstseins-Punktzahl', 'score.subtitle': 'Verfolge deine Bewusstseins-Evolution',
    'rx.title': 'Frequenz-Rezept', 'rx.subtitle': 'Personalisierte Heilfrequenzen basierend auf deinem Zustand',
    'sound.title': 'Klang-Heilung', 'sound.subtitle': 'Heilige Frequenzen für Transformation und Heilung',
    'holistic.title': 'Ganzheitliche Heilung', 'holistic.subtitle': 'Integrierte Wellness-Tools und Praktiken',
    'community.title': 'Bewusste Gemeinschaft', 'community.subtitle': 'Verbinde dich mit anderen auf dem Heilungsweg',
    'subscription.title': 'Wähle Deinen Weg', 'subscription.subtitle': '30 Tage kostenlos testen, keine Kreditkarte erforderlich',
    'landing.hero': 'Wechsle vom Opfer', 'landing.hero2': 'zum Schöpferbewusstsein',
    'landing.subtitle': 'Ein ganzheitliches Heilungsökosystem mit Echtzeit-Biofeedback und KI-Personalisierung.',
    'landing.cta': 'Beginne Deine Reise', 'landing.explore': 'Funktionen Entdecken',
    'landing.community_cta': 'Tritt der Bewussten Gemeinschaft Bei',
    'landing.community_desc': 'Verbinde dich mit anderen auf dem Weg der Eigenverantwortung.',
    'landing.begin': 'Bewusstsein Beginnen',
    'auth.login': 'Anmelden', 'auth.register': 'Konto Erstellen',
    'auth.email': 'E-Mail', 'auth.password': 'Passwort', 'auth.name': 'Vollständiger Name',
    'dashboard.greeting': 'Guten Tag',
    'hrv.title': 'HRV-Monitor', 'hrv.subtitle': 'Echtzeit-Herzfrequenzvariabilität',
    'eeg.title': 'EEG-Monitor', 'eeg.subtitle': 'Gehirnwellen-Visualisierung',
    'meditation.title': 'Meditationsskripte', 'meditation.subtitle': 'KI-generierte Skripte. Nimm mit deiner Stimme auf.',
    'meditation.generate': 'Neues Skript Erstellen',
    'milestones.title': 'Heilungs-Meilensteine', 'milestones.subtitle': 'Feiere deine Bewusstseinsevolution',
    'milestones.share': 'Reise Teilen', 'milestones.copy': 'Text Kopieren',
    'common.loading': 'Laden...', 'common.save': 'Speichern', 'common.cancel': 'Abbrechen',
    'common.start': 'Starten', 'common.stop': 'Stoppen', 'common.history': 'Verlauf',
    'common.monitor': 'Monitor', 'common.sessions': 'Sitzungen',
    'common.improving': 'Verbesserung', 'common.declining': 'Rückgang', 'common.stable': 'Stabil',
    'dashboard.enter_haven': 'Zuflucht Betreten',
    'dashboard.haven_subtitle': 'Ich bin hier. Sprich mit mir und wir finden gemeinsam eine Lösung.',
    'dashboard.begin_conversation': 'Mit Haven Sprechen',
    'dashboard.start_ritual': 'Sequenz Starten',
    'dashboard.sequence_desc': 'Entwickelt, um deinen Zustand zu regulieren und deinen Geist neu zu fokussieren.',
    'dashboard.morning_checkin': 'Morgen-Check',
    'dashboard.checkin_time': '90 Sekunden zum Einstimmen',
    'dashboard.sound_healing': 'Klangtherapie',
    'dashboard.frequencies': 'Frequenzen',
    'dashboard.hrv_monitor': 'HRV-Monitor',
    'dashboard.biofeedback': 'Biofeedback',
    'dashboard.patterns': 'Muster',
    'dashboard.no_patterns': 'Noch keine Muster',
    'dashboard.nothing_active': 'Noch nichts aktiv',
    'dashboard.tracked': 'verfolgt',
    'dashboard.journal': 'Tagebuch',
    'dashboard.reflect': 'Reflektieren',
    'dashboard.crystal_liberation': 'Kristall-Befreiung',
    'dashboard.matrix_exit': 'Matrix-Ausgang',
    'dashboard.binaural_beats': 'Binaurale Beats',
    'dashboard.brainwaves': 'Gehirnwellen',
    'dashboard.reality_shifts': 'Realitätsverschiebungen',
    'dashboard.experiments': 'Experimente',
    'dashboard.active': 'aktiv',
    'dashboard.todays_checkin': 'Heutiger Check-In',
    'dashboard.mood': 'Stimmung',
    'dashboard.energy': 'Energie',
    'dashboard.intention': 'Absicht',
    'dashboard.explore_all_features': 'Alle Funktionen Erkunden',
    'features.title': 'Alle Funktionen',
    'features.subtitle': 'Dein komplettes Toolkit für Bewusstseinstransformation',
    'features.back_to_dashboard': 'Zurück zum Dashboard',
    'features.category_ai': 'KI und Intelligenz',
    'features.category_sound': 'Klang und Frequenz',
    'features.category_biofeedback': 'Biofeedback und Sensoren',
    'features.category_tracking': 'Tracking und Tagebuch',
    'features.category_healing': 'Heilung und Wellness',
    'features.category_cosmic': 'Kosmische und Erdenergie',
    'features.category_community': 'Community und Spiele',
    'features.haven_ai': 'Haven KI', 'features.haven_ai_desc': 'Dein Bewusstseinsspiegel',
    'features.crystal_liberation': 'Kristall-Befreiung', 'features.crystal_liberation_desc': 'Mustertransformation',
    'features.frequency_rx': 'Frequenz Rx', 'features.frequency_rx_desc': 'Personalisierte Rezepte',
    'features.sound_healing': 'Klangtherapie', 'features.sound_healing_desc': 'Heilige Frequenzen',
    'features.binaural_beats': 'Binaurale Beats', 'features.binaural_beats_desc': 'Gehirnwellen-Entrainment',
    'features.crystal_combos': 'Kristall-Mischungen', 'features.crystal_combos_desc': 'Harmonische Synergien',
    'features.hrv_monitor': 'HRV Monitor', 'features.hrv_monitor_desc': 'Herzkohärenz-Tracking',
    'features.eeg_monitor': 'EEG Monitor', 'features.eeg_monitor_desc': 'Gehirnwellen-Visualisierung',
    'features.sensor_hub': 'Sensor-Hub', 'features.sensor_hub_desc': 'Geräteverbindungen',
    'features.energy_scan': 'Energie-Scan', 'features.energy_scan_desc': 'Biofeld-Analyse',
    'features.patterns': 'Muster', 'features.patterns_desc': 'Verhaltensbewusstsein',
    'features.journal': 'Tagebuch', 'features.journal_desc': 'Tägliche Reflexionen',
    'features.dreams': 'Traumtagebuch', 'features.dreams_desc': 'Traumanalyse',
    'features.consciousness': 'Bewusstseins-Score', 'features.consciousness_desc': 'Awareness-Metriken',
    'features.reality_shifts': 'Realitätsverschiebungen', 'features.reality_shifts_desc': 'Manifestations-Tracking',
    'features.experiments': 'Experimente', 'features.experiments_desc': 'Bewusstseins-Labore',
    'features.daily_ritual': 'Tägliches Ritual', 'features.daily_ritual_desc': 'Geführte Sequenzen',
    'features.holistic': 'Ganzheitliche Heilung', 'features.holistic_desc': 'Integriertes Wohlbefinden',
    'features.health_tracking': 'Gesundheits-Tracking', 'features.health_tracking_desc': 'Vitalwerte-Dashboard',
    'features.nutrition': 'Ernährungsguide', 'features.nutrition_desc': 'Bewusste Ernährung',
    'features.astrology': 'Kosmische Ausrichtung', 'features.astrology_desc': 'Planetenpositionen',
    'features.ley_lines': 'Ley-Linien', 'features.ley_lines_desc': 'Erdgitter-Kartierung',
    'features.community': 'Community', 'features.community_desc': 'Verbinde dich mit anderen',
    'features.milestones': 'Meilensteine', 'features.milestones_desc': 'Erfolge teilen',
    'features.mind_games': 'Gedankenspiele', 'features.mind_games_desc': 'Fokus-Übungen',
    'landing.ecosystem_title': 'Das Heilungs-Ökosystem',
    'landing.ecosystem_subtitle': 'Jedes Werkzeug verbunden. Jede Datenquelle real. Jede Erkenntnis personalisiert.',
    'landing.footer': 'NeuroHeal — Bewusstseinsbasiertes Heilungs-Ökosystem',
    'feature.pattern_recognition': 'Mustererkennung',
    'feature.pattern_desc': 'Identifiziere unbewusste Verhaltensmuster, die wiederkehrende Herausforderungen schaffen.',
    'feature.haven_ai': 'Haven KI',
    'feature.haven_desc': 'Dein Bewusstseinsspiegel, angetrieben von GPT-4o.',
    'feature.hrv_biofeedback': 'HRV-Biofeedback',
    'feature.hrv_desc': 'Echtzeit-Herzkohärenz via Bluetooth LE Sensoren.',
    'feature.sound_healing': 'Klangtherapie',
    'feature.sound_desc': 'Solfeggio-Frequenzen und binaurale Beats für tiefe Heilung.',
    'feature.astro_alignment': 'Astro-Ausrichtung',
    'feature.astro_desc': 'Echte Ephemeridendaten mit NOAA geomagnetischen Feeds.',
    'feature.crystal_protocol': 'Kristall-Protokoll',
    'feature.crystal_desc': 'Biofrequenz-Befreiung mit heiliger Geometrie-Harmonik.',
    'auth.welcome_back': 'Willkommen zurück, Schöpfer',
    'auth.begin_transformation': 'Beginne deine Transformation',
    'auth.name_label': 'Name',
    'auth.email_label': 'E-Mail',
    'auth.password_label': 'Passwort',
    'auth.sign_in': 'Anmelden',
    'auth.create_account': 'Konto Erstellen',
    'auth.no_account': 'Kein Konto? Registrieren',
    'auth.has_account': 'Bereits ein Konto? Anmelden',
    'auth.processing': 'Verarbeite...',
    'haven.title': 'Zuflucht',
    'haven.subtitle': 'Dein Bewusstseinsspiegel und Awareness-Guide',
    'haven.welcome': 'Willkommen, Schöpfer',
    'haven.welcome_message': 'Ich bin Haven, dein Bewusstseinsspiegel. Teile was dich beschäftigt und lass uns die Muster erkunden, die deine Realität formen.',
    'haven.voice_tip': 'Tipp: Tippe auf das Mikrofon um zu sprechen',
    'haven.placeholder': 'Teile was dich beschäftigt...',
    'haven.voice_enabled': 'Haven Stimme',
    'haven.voice_off': 'Stimme Aus',
    'haven.speaking': 'Spricht...',
    'haven.listening': 'Hört zu...',
    'binaural.title': 'Binaurale Beat-Generator',
    'binaural.subtitle': 'Gehirnwellen-Entrainment personalisiert nach deinem Bewusstseins-Score',
    'binaural.headphones': 'Kopfhörer für optimalen Effekt verwenden',
    'binaural.preset_programs': 'Voreingestellte Programme',
    'binaural.ai_personalized': 'KI-Personalisiert',
    'binaural.custom_beat': 'Eigener Beat',
    'binaural.stop_session': 'Sitzung Beenden',
    'binaural.start_program': 'Programm Starten',
    'binaural.generate_program': 'Mein Programm Generieren',
    'binaural.analyzing': 'Analysiere Bewusstsein...',
    'binaural.brainwave_state': 'Gehirnwellen-Zustand',
    'binaural.carrier_frequency': 'Trägerfrequenz',
    'binaural.duration': 'Dauer',
    'binaural.start_custom': 'Eigene Sitzung Starten',
    'binaural.your_stats': 'Deine Statistiken',
    'binaural.total_sessions': 'Gesamte Sitzungen',
    'binaural.total_minutes': 'Gesamte Minuten',
    'binaural.brainwave_guide': 'Gehirnwellen-Guide',
    'binaural.headphones_required': 'Kopfhörer Erforderlich',
    'binaural.headphones_desc': 'Binaurale Beats erfordern Stereo-Kopfhörer. Jedes Ohr empfängt eine leicht unterschiedliche Frequenz, die den Entrainment-Effekt in deinem Gehirn erzeugt.',
    'settings.title': 'Einstellungen',
    'settings.profile': 'Profil',
    'settings.subscription': 'Abonnement',
    'settings.frequency_sessions': 'Frequenz & Sitzungen',
    'settings.default_frequency': 'Standard-Frequenz (Hz)',
    'settings.session_duration': 'Sitzungsdauer (min)',
    'settings.preferred_breathwork': 'Bevorzugte Atemübung',
    'settings.preferences': 'Einstellungen',
    'settings.dark_mode': 'Dunkelmodus',
    'settings.notifications': 'Benachrichtigungen',
    'settings.auto_play': 'Auto-Wiedergabe',
    'settings.lunar_info': 'Mond-Info Anzeigen',
    'settings.save_profile': 'Profil Speichern',
    'settings.save_all': 'Alle Speichern',
    'settings.manage_subscription': 'Abonnement Verwalten',
    'settings.subscribe_now': 'Jetzt Abonnieren',
    'settings.support': 'Support',
    'settings.support_desc': 'Brauchst du Hilfe mit NeuroHeal? Kontaktiere uns und wir antworten schnellstmöglich.',
    'help.title': 'Hilfe & Support',
    'help.subtitle': 'Wir sind hier um dir auf deiner Heilungsreise zu helfen',
    'help.contact': 'Support Kontaktieren',
    'help.contact_desc': 'Hole Hilfe von unserem Team',
    'help.email_desc': 'Frage, Feedback oder Problem? Schreib uns und wir antworten schnellstmöglich.',
    'help.quick_links': 'Schnelllinks',
    'help.account_settings': 'Konto & Einstellungen',
    'help.subscription_billing': 'Abonnement & Abrechnung',
    'help.ask_haven': 'Haven KI fragen',
    'help.faq': 'Häufige Fragen',
    'help.response_time': 'Typische Antwortzeit: 24-48 Stunden',
    'status.active': 'Aktiv',
    'status.trial': 'Testversion',
    'status.expired': 'Abgelaufen',
    'status.loading': 'Laden...',
    'status.days_left': 'Tage übrig',
  },
  zh: {
    'nav.home': '首页', 'nav.haven': '避风港', 'nav.dashboard': '仪表盘',
    'nav.patterns': '模式', 'nav.journal': '日记', 'nav.sound': '声音',
    'nav.hrv': '心率变异', 'nav.eeg': '脑电图', 'nav.meditate': '冥想',
    'nav.milestones': '里程碑', 'nav.community': '社区',
    'nav.settings': '设置', 'nav.logout': '退出',
    'nav.games': '游戏', 'nav.crystals': '水晶', 'nav.blend': '混合',
    'nav.binaural': '双耳节拍', 'nav.cosmic': '宇宙', 'nav.dreams': '梦境',
    'nav.score': '分数', 'nav.rx': '处方', 'nav.ceremonies': '仪式',
    'nav.holistic': '整体', 'nav.help': '帮助',
    'games.title': '心智游戏', 'games.subtitle': '5-10分钟专注、记忆和平静练习',
    'ceremonies.title': '神圣仪式', 'ceremonies.subtitle': '团体冥想仪式和神圣声音体验',
    'crystals.title': '水晶解放协议', 'crystals.subtitle': '模式分析和意识转化',
    'blend.title': '水晶组合', 'blend.subtitle': '发现强大的水晶协同和治疗混合',
    'cosmic.title': '宇宙对齐', 'cosmic.subtitle': '实时行星位置和意识指导',
    'dreams.title': '梦境日记', 'dreams.subtitle': '记录和分析你的梦境模式',
    'score.title': '意识分数', 'score.subtitle': '追踪你的觉知进化',
    'rx.title': '频率处方', 'rx.subtitle': '基于你状态的个性化治疗频率',
    'sound.title': '声音疗愈', 'sound.subtitle': '用于转化和治疗的神圣频率',
    'holistic.title': '整体疗愈', 'holistic.subtitle': '整合健康工具和实践',
    'community.title': '觉醒社区', 'community.subtitle': '与其他在疗愈道路上的人连接',
    'subscription.title': '选择你的道路', 'subscription.subtitle': '30天免费试用，无需信用卡',
    'landing.hero': '从受害者意识', 'landing.hero2': '转变为创造者意识',
    'landing.subtitle': '一个由实时生物反馈、实时宇宙数据和AI驱动个性化的整体治疗生态系统。',
    'landing.cta': '开始你的旅程', 'landing.explore': '探索功能',
    'landing.community_cta': '加入觉醒社区',
    'landing.community_desc': '与其他走在自我责任和源头觉知道路上的人连接。',
    'landing.begin': '开始觉醒',
    'auth.login': '登录', 'auth.register': '创建账户',
    'auth.email': '邮箱', 'auth.password': '密码', 'auth.name': '全名',
    'dashboard.greeting': '您好',
    'hrv.title': '心率变异监测', 'hrv.subtitle': '实时心率变异性监测',
    'eeg.title': '脑电图监测', 'eeg.subtitle': '脑波可视化',
    'meditation.title': '冥想脚本', 'meditation.subtitle': 'AI生成的个性化脚本。用你自己的声音录制。',
    'meditation.generate': '生成新脚本',
    'milestones.title': '治疗里程碑', 'milestones.subtitle': '庆祝并分享你的意识进化',
    'milestones.share': '分享旅程', 'milestones.copy': '复制文本',
    'common.loading': '加载中...', 'common.save': '保存', 'common.cancel': '取消',
    'common.start': '开始', 'common.stop': '停止', 'common.history': '历史',
    'common.monitor': '监测', 'common.sessions': '次会话',
    'common.improving': '改善中', 'common.declining': '下降中', 'common.stable': '稳定',
    'dashboard.enter_haven': '进入避风港',
    'dashboard.haven_subtitle': '我在这里。和我聊聊，我们一起想办法。',
    'dashboard.begin_conversation': '与Haven对话',
    'dashboard.start_ritual': '开始序列',
    'dashboard.sequence_desc': '旨在帮助你调节状态，重新集中注意力。',
    'dashboard.morning_checkin': '晨间签到',
    'dashboard.checkin_time': '90秒调频',
    'dashboard.sound_healing': '声音疗愈',
    'dashboard.frequencies': '频率',
    'dashboard.hrv_monitor': '心率变异监测',
    'dashboard.biofeedback': '生物反馈',
    'dashboard.patterns': '模式',
    'dashboard.no_patterns': '暂无模式',
    'dashboard.nothing_active': '暂无活动',
    'dashboard.tracked': '已追踪',
    'dashboard.journal': '日记',
    'dashboard.reflect': '反思',
    'dashboard.crystal_liberation': '水晶解放',
    'dashboard.matrix_exit': '矩阵出口',
    'dashboard.binaural_beats': '双耳节拍',
    'dashboard.brainwaves': '脑波',
    'dashboard.reality_shifts': '现实转变',
    'dashboard.experiments': '实验',
    'dashboard.active': '活跃',
    'dashboard.todays_checkin': '今日签到',
    'dashboard.mood': '心情',
    'dashboard.energy': '能量',
    'dashboard.intention': '意图',
    'dashboard.explore_all_features': '探索所有功能',
    'features.title': '所有功能',
    'features.subtitle': '你的意识转化完整工具包',
    'features.back_to_dashboard': '返回仪表板',
    'features.category_ai': 'AI与智能',
    'features.category_sound': '声音与频率',
    'features.category_biofeedback': '生物反馈与传感器',
    'features.category_tracking': '追踪与日记',
    'features.category_healing': '疗愈与健康',
    'features.category_cosmic': '宇宙与地球能量',
    'features.category_community': '社区与游戏',
    'features.haven_ai': 'Haven AI', 'features.haven_ai_desc': '你的意识镜子',
    'features.crystal_liberation': '水晶解放', 'features.crystal_liberation_desc': '模式转化',
    'features.frequency_rx': '频率处方', 'features.frequency_rx_desc': '个性化处方',
    'features.sound_healing': '声音疗愈', 'features.sound_healing_desc': '神圣频率',
    'features.binaural_beats': '双耳节拍', 'features.binaural_beats_desc': '脑波同步',
    'features.crystal_combos': '水晶组合', 'features.crystal_combos_desc': '和谐协同',
    'features.hrv_monitor': '心率变异监测', 'features.hrv_monitor_desc': '心脏一致性追踪',
    'features.eeg_monitor': '脑电图监测', 'features.eeg_monitor_desc': '脑波可视化',
    'features.sensor_hub': '传感器中心', 'features.sensor_hub_desc': '设备连接',
    'features.energy_scan': '能量扫描', 'features.energy_scan_desc': '生物场分析',
    'features.patterns': '模式', 'features.patterns_desc': '行为意识',
    'features.journal': '日记', 'features.journal_desc': '日常反思',
    'features.dreams': '梦境日记', 'features.dreams_desc': '梦境分析',
    'features.consciousness': '意识分数', 'features.consciousness_desc': '觉知指标',
    'features.reality_shifts': '现实转变', 'features.reality_shifts_desc': '显化追踪',
    'features.experiments': '实验', 'features.experiments_desc': '意识实验室',
    'features.daily_ritual': '每日仪式', 'features.daily_ritual_desc': '引导序列',
    'features.holistic': '整体疗愈', 'features.holistic_desc': '综合健康',
    'features.health_tracking': '健康追踪', 'features.health_tracking_desc': '生命体征仪表板',
    'features.nutrition': '营养指南', 'features.nutrition_desc': '有意识饮食',
    'features.astrology': '宇宙对齐', 'features.astrology_desc': '行星位置',
    'features.ley_lines': '能量线', 'features.ley_lines_desc': '地球网格映射',
    'features.community': '社区', 'features.community_desc': '与他人连接',
    'features.milestones': '里程碑', 'features.milestones_desc': '成就分享',
    'features.mind_games': '智力游戏', 'features.mind_games_desc': '专注练习',
    'landing.ecosystem_title': '疗愈生态系统',
    'landing.ecosystem_subtitle': '每个工具都连接。每个数据源都真实。每个洞察都个性化。',
    'landing.footer': 'NeuroHeal — 基于意识的疗愈生态系统',
    'feature.pattern_recognition': '模式识别',
    'feature.pattern_desc': '识别造成反复挑战的无意识行为循环。',
    'feature.haven_ai': 'Haven人工智能',
    'feature.haven_desc': '你的意识镜子，由GPT-4o驱动。',
    'feature.hrv_biofeedback': '心率变异生物反馈',
    'feature.hrv_desc': '通过蓝牙LE传感器实时心脏一致性。',
    'feature.sound_healing': '声音疗愈',
    'feature.sound_desc': '用于深度疗愈的Solfeggio频率和双耳节拍。',
    'feature.astro_alignment': '天文对齐',
    'feature.astro_desc': '真实星历数据与NOAA地磁实时数据。',
    'feature.crystal_protocol': '水晶协议',
    'feature.crystal_desc': '神圣几何谐波的生物频率解放。',
    'auth.welcome_back': '欢迎回来，创造者',
    'auth.begin_transformation': '开始你的转变',
    'auth.name_label': '姓名',
    'auth.email_label': '邮箱',
    'auth.password_label': '密码',
    'auth.sign_in': '登录',
    'auth.create_account': '创建账户',
    'auth.no_account': '没有账户？注册',
    'auth.has_account': '已有账户？登录',
    'auth.processing': '处理中...',
    'haven.title': '避风港',
    'haven.subtitle': '你的意识镜子和觉知指南',
    'haven.welcome': '欢迎，创造者',
    'haven.welcome_message': '我是Haven，你的意识镜子。分享你的想法，让我们一起探索塑造你现实的模式。',
    'haven.voice_tip': '提示：点击麦克风说话',
    'haven.placeholder': '分享你的想法...',
    'haven.voice_enabled': 'Haven语音',
    'haven.voice_off': '语音关闭',
    'haven.speaking': '正在说话...',
    'haven.listening': '正在听...',
    'binaural.title': '双耳节拍生成器',
    'binaural.subtitle': '根据你的意识分数个性化的脑波同步',
    'binaural.headphones': '使用耳机以获得最佳效果',
    'binaural.preset_programs': '预设程序',
    'binaural.ai_personalized': 'AI个性化',
    'binaural.custom_beat': '自定义节拍',
    'binaural.stop_session': '停止会话',
    'binaural.start_program': '开始程序',
    'binaural.generate_program': '生成我的程序',
    'binaural.analyzing': '分析意识中...',
    'binaural.brainwave_state': '脑波状态',
    'binaural.carrier_frequency': '载波频率',
    'binaural.duration': '时长',
    'binaural.start_custom': '开始自定义会话',
    'binaural.your_stats': '你的统计',
    'binaural.total_sessions': '总会话数',
    'binaural.total_minutes': '总分钟数',
    'binaural.brainwave_guide': '脑波指南',
    'binaural.headphones_required': '需要耳机',
    'binaural.headphones_desc': '双耳节拍需要立体声耳机才能工作。每只耳朵接收略微不同的频率，在大脑中产生同步效果。',
    'settings.title': '设置',
    'settings.profile': '个人资料',
    'settings.subscription': '订阅',
    'settings.frequency_sessions': '频率和会话',
    'settings.default_frequency': '默认频率 (Hz)',
    'settings.session_duration': '会话时长 (分钟)',
    'settings.preferred_breathwork': '首选呼吸法',
    'settings.preferences': '偏好设置',
    'settings.dark_mode': '深色模式',
    'settings.notifications': '通知',
    'settings.auto_play': '自动播放声音',
    'settings.lunar_info': '显示月相信息',
    'settings.save_profile': '保存资料',
    'settings.save_all': '保存所有设置',
    'settings.manage_subscription': '管理订阅',
    'settings.subscribe_now': '立即订阅',
    'settings.support': '支持',
    'settings.support_desc': '需要NeuroHeal的帮助？随时联系我们，我们会尽快回复。',
    'help.title': '帮助与支持',
    'help.subtitle': '我们在这里帮助你的疗愈之旅',
    'help.contact': '联系支持',
    'help.contact_desc': '获得我们团队的帮助',
    'help.email_desc': '有问题、反馈或问题？给我们发邮件，我们会尽快回复。',
    'help.quick_links': '快速链接',
    'help.account_settings': '账户与设置',
    'help.subscription_billing': '订阅与账单',
    'help.ask_haven': '询问Haven AI',
    'help.faq': '常见问题',
    'help.response_time': '典型响应时间：24-48小时',
    'status.active': '活跃',
    'status.trial': '试用',
    'status.expired': '已过期',
    'status.loading': '加载中...',
    'status.days_left': '天剩余',
  },
  pt: {
    'nav.home': 'Início', 'nav.haven': 'Refúgio', 'nav.dashboard': 'Painel',
    'nav.patterns': 'Padrões', 'nav.journal': 'Diário', 'nav.sound': 'Som',
    'nav.hrv': 'VFC', 'nav.eeg': 'EEG', 'nav.meditate': 'Meditar',
    'nav.milestones': 'Marcos', 'nav.community': 'Comunidade',
    'nav.settings': 'Configurações', 'nav.logout': 'Sair',
    'nav.games': 'Jogos', 'nav.crystals': 'Cristais', 'nav.blend': 'Mistura',
    'nav.binaural': 'Binaural', 'nav.cosmic': 'Cósmico', 'nav.dreams': 'Sonhos',
    'nav.score': 'Pontuação', 'nav.rx': 'Rx', 'nav.ceremonies': 'Cerimônias',
    'nav.holistic': 'Holístico', 'nav.help': 'Ajuda',
    'games.title': 'Jogos Mentais', 'games.subtitle': 'Exercícios de 5-10 minutos para foco, memória e calma',
    'ceremonies.title': 'Cerimônias Sagradas', 'ceremonies.subtitle': 'Rituais de meditação em grupo e sons sagrados',
    'crystals.title': 'Protocolo de Liberação Cristal', 'crystals.subtitle': 'Análise de padrões e transformação de consciência',
    'blend.title': 'Combinações de Cristais', 'blend.subtitle': 'Descubra sinergias poderosas e misturas de cura',
    'cosmic.title': 'Alinhamento Cósmico', 'cosmic.subtitle': 'Posições planetárias em tempo real e orientação',
    'dreams.title': 'Diário de Sonhos', 'dreams.subtitle': 'Registre e analise seus padrões de sonhos',
    'score.title': 'Pontuação de Consciência', 'score.subtitle': 'Acompanhe sua evolução de consciência',
    'rx.title': 'Prescrição de Frequência', 'rx.subtitle': 'Frequências de cura personalizadas com base no seu estado',
    'sound.title': 'Cura pelo Som', 'sound.subtitle': 'Frequências sagradas para transformação e cura',
    'holistic.title': 'Cura Holística', 'holistic.subtitle': 'Ferramentas e práticas de bem-estar integradas',
    'community.title': 'Comunidade Consciente', 'community.subtitle': 'Conecte-se com outros no caminho de cura',
    'subscription.title': 'Escolha Seu Caminho', 'subscription.subtitle': '30 dias grátis, sem cartão de crédito',
    'landing.hero': 'Mude da Vítima', 'landing.hero2': 'para Consciência Criadora',
    'landing.subtitle': 'Um ecossistema de cura holística com biofeedback real, dados cósmicos ao vivo e personalização por IA.',
    'landing.cta': 'Comece Sua Jornada', 'landing.explore': 'Explorar Recursos',
    'landing.community_cta': 'Junte-se à Comunidade Consciente',
    'landing.community_desc': 'Conecte-se com outros no caminho da auto-responsabilidade.',
    'landing.begin': 'Começar Consciência',
    'auth.login': 'Entrar', 'auth.register': 'Criar Conta',
    'auth.email': 'E-mail', 'auth.password': 'Senha', 'auth.name': 'Nome Completo',
    'dashboard.greeting': 'Bom dia',
    'hrv.title': 'Monitor VFC', 'hrv.subtitle': 'Variabilidade cardíaca em tempo real',
    'eeg.title': 'Monitor EEG', 'eeg.subtitle': 'Visualização de ondas cerebrais',
    'meditation.title': 'Scripts de Meditação', 'meditation.subtitle': 'Scripts IA personalizados. Grave com sua voz.',
    'meditation.generate': 'Gerar Novo Script',
    'milestones.title': 'Marcos de Cura', 'milestones.subtitle': 'Celebre sua evolução de consciência',
    'milestones.share': 'Compartilhar Jornada', 'milestones.copy': 'Copiar Texto',
    'common.loading': 'Carregando...', 'common.save': 'Salvar', 'common.cancel': 'Cancelar',
    'common.start': 'Iniciar', 'common.stop': 'Parar', 'common.history': 'Histórico',
    'common.monitor': 'Monitor', 'common.sessions': 'sessões',
    'common.improving': 'Melhorando', 'common.declining': 'Em declínio', 'common.stable': 'Estável',
    'dashboard.enter_haven': 'Entrar no Refúgio',
    'dashboard.haven_subtitle': 'Estou aqui. Fale comigo e vamos resolver isso juntos.',
    'dashboard.begin_conversation': 'Falar com Haven',
    'dashboard.start_ritual': 'Iniciar Sequência',
    'dashboard.sequence_desc': 'Projetado para ajudar a regular seu estado e refocar sua mente.',
    'dashboard.morning_checkin': 'Check-In Matinal',
    'dashboard.checkin_time': '90 segundos para sintonizar',
    'dashboard.sound_healing': 'Cura Sonora',
    'dashboard.frequencies': 'Frequências',
    'dashboard.hrv_monitor': 'Monitor VFC',
    'dashboard.biofeedback': 'Biofeedback',
    'dashboard.patterns': 'Padrões',
    'dashboard.no_patterns': 'Nenhum padrão ainda',
    'dashboard.nothing_active': 'Nada ativo ainda',
    'dashboard.tracked': 'rastreados',
    'dashboard.journal': 'Diário',
    'dashboard.reflect': 'Refletir',
    'dashboard.crystal_liberation': 'Liberação Cristal',
    'dashboard.matrix_exit': 'Saída da Matrix',
    'dashboard.binaural_beats': 'Batidas Binaurais',
    'dashboard.brainwaves': 'Ondas Cerebrais',
    'dashboard.reality_shifts': 'Mudanças de Realidade',
    'dashboard.experiments': 'Experimentos',
    'dashboard.active': 'ativos',
    'dashboard.todays_checkin': 'Check-In de Hoje',
    'dashboard.mood': 'Humor',
    'dashboard.energy': 'Energia',
    'dashboard.intention': 'Intenção',
    'dashboard.explore_all_features': 'Explorar Todas as Funcionalidades',
    'features.title': 'Todas as Funcionalidades',
    'features.subtitle': 'Seu kit completo para transformação de consciência',
    'features.back_to_dashboard': 'Voltar ao Painel',
    'features.category_ai': 'IA e Inteligência',
    'features.category_sound': 'Som e Frequência',
    'features.category_biofeedback': 'Biofeedback e Sensores',
    'features.category_tracking': 'Rastreamento e Diário',
    'features.category_healing': 'Cura e Bem-estar',
    'features.category_cosmic': 'Energia Cósmica e Terrestre',
    'features.category_community': 'Comunidade e Jogos',
    'features.haven_ai': 'Haven IA', 'features.haven_ai_desc': 'Seu espelho de consciência',
    'features.crystal_liberation': 'Liberação Cristal', 'features.crystal_liberation_desc': 'Transformação de padrões',
    'features.frequency_rx': 'Frequência Rx', 'features.frequency_rx_desc': 'Prescrições personalizadas',
    'features.sound_healing': 'Cura Sonora', 'features.sound_healing_desc': 'Frequências sagradas',
    'features.binaural_beats': 'Batidas Binaurais', 'features.binaural_beats_desc': 'Sincronização cerebral',
    'features.crystal_combos': 'Combinações Cristal', 'features.crystal_combos_desc': 'Sinergias harmônicas',
    'features.hrv_monitor': 'Monitor VFC', 'features.hrv_monitor_desc': 'Rastreamento de coerência cardíaca',
    'features.eeg_monitor': 'Monitor EEG', 'features.eeg_monitor_desc': 'Visualização de ondas cerebrais',
    'features.sensor_hub': 'Hub de Sensores', 'features.sensor_hub_desc': 'Conexões de dispositivos',
    'features.energy_scan': 'Scan de Energia', 'features.energy_scan_desc': 'Análise de biocampo',
    'features.patterns': 'Padrões', 'features.patterns_desc': 'Consciência comportamental',
    'features.journal': 'Diário', 'features.journal_desc': 'Reflexões diárias',
    'features.dreams': 'Diário de Sonhos', 'features.dreams_desc': 'Análise de sonhos',
    'features.consciousness': 'Pontuação de Consciência', 'features.consciousness_desc': 'Métricas de awareness',
    'features.reality_shifts': 'Mudanças de Realidade', 'features.reality_shifts_desc': 'Rastreamento de manifestação',
    'features.experiments': 'Experimentos', 'features.experiments_desc': 'Laboratórios de consciência',
    'features.daily_ritual': 'Ritual Diário', 'features.daily_ritual_desc': 'Sequências guiadas',
    'features.holistic': 'Cura Holística', 'features.holistic_desc': 'Bem-estar integrado',
    'features.health_tracking': 'Rastreamento de Saúde', 'features.health_tracking_desc': 'Painel de sinais vitais',
    'features.nutrition': 'Guia Nutricional', 'features.nutrition_desc': 'Alimentação consciente',
    'features.astrology': 'Alinhamento Cósmico', 'features.astrology_desc': 'Posições planetárias',
    'features.ley_lines': 'Linhas Ley', 'features.ley_lines_desc': 'Mapeamento de grade terrestre',
    'features.community': 'Comunidade', 'features.community_desc': 'Conecte-se com outros',
    'features.milestones': 'Marcos', 'features.milestones_desc': 'Compartilhamento de conquistas',
    'features.mind_games': 'Jogos Mentais', 'features.mind_games_desc': 'Exercícios de foco',
    'landing.ecosystem_title': 'O Ecossistema de Cura',
    'landing.ecosystem_subtitle': 'Cada ferramenta conectada. Cada fonte de dados real. Cada insight personalizado.',
    'landing.footer': 'NeuroHeal — Ecossistema de Cura Baseado em Consciência',
    'feature.pattern_recognition': 'Reconhecimento de Padrões',
    'feature.pattern_desc': 'Identifique loops de comportamento inconsciente que criam desafios recorrentes.',
    'feature.haven_ai': 'Haven IA',
    'feature.haven_desc': 'Seu espelho de consciência alimentado por GPT-4o.',
    'feature.hrv_biofeedback': 'Biofeedback VFC',
    'feature.hrv_desc': 'Coerência cardíaca em tempo real via sensores Bluetooth LE.',
    'feature.sound_healing': 'Cura Sonora',
    'feature.sound_desc': 'Frequências Solfeggio e batidas binaurais para cura profunda.',
    'feature.astro_alignment': 'Alinhamento Astral',
    'feature.astro_desc': 'Dados de efemérides reais com feeds geomagnéticos NOAA.',
    'feature.crystal_protocol': 'Protocolo Cristal',
    'feature.crystal_desc': 'Liberação de biofrequência com harmônicos de geometria sagrada.',
    'auth.welcome_back': 'Bem-vindo de volta, Criador',
    'auth.begin_transformation': 'Comece sua transformação',
    'auth.name_label': 'Nome',
    'auth.email_label': 'E-mail',
    'auth.password_label': 'Senha',
    'auth.sign_in': 'Entrar',
    'auth.create_account': 'Criar Conta',
    'auth.no_account': 'Não tem conta? Cadastre-se',
    'auth.has_account': 'Já tem conta? Entre',
    'auth.processing': 'Processando...',
    'haven.title': 'Refúgio',
    'haven.subtitle': 'Seu espelho de consciência e guia de awareness',
    'haven.welcome': 'Bem-vindo, Criador',
    'haven.welcome_message': 'Sou Haven, seu espelho de consciência. Compartilhe o que está em sua mente e vamos explorar os padrões que moldam sua realidade.',
    'haven.voice_tip': 'Dica: Toque no microfone para falar',
    'haven.placeholder': 'Compartilhe o que está em sua mente...',
    'haven.voice_enabled': 'Voz do Haven',
    'haven.voice_off': 'Voz Desligada',
    'haven.speaking': 'Falando...',
    'haven.listening': 'Ouvindo...',
    'binaural.title': 'Gerador de Batidas Binaurais',
    'binaural.subtitle': 'Sincronização cerebral personalizada segundo sua pontuação de consciência',
    'binaural.headphones': 'Use fones de ouvido para efeito ideal',
    'binaural.preset_programs': 'Programas Predefinidos',
    'binaural.ai_personalized': 'Personalizado por IA',
    'binaural.custom_beat': 'Batida Personalizada',
    'binaural.stop_session': 'Parar Sessão',
    'binaural.start_program': 'Iniciar Programa',
    'binaural.generate_program': 'Gerar Meu Programa',
    'binaural.analyzing': 'Analisando consciência...',
    'binaural.brainwave_state': 'Estado de Onda Cerebral',
    'binaural.carrier_frequency': 'Frequência Portadora',
    'binaural.duration': 'Duração',
    'binaural.start_custom': 'Iniciar Sessão Personalizada',
    'binaural.your_stats': 'Suas Estatísticas',
    'binaural.total_sessions': 'Sessões Totais',
    'binaural.total_minutes': 'Minutos Totais',
    'binaural.brainwave_guide': 'Guia de Ondas Cerebrais',
    'binaural.headphones_required': 'Fones Necessários',
    'binaural.headphones_desc': 'Batidas binaurais requerem fones de ouvido estéreo. Cada ouvido recebe uma frequência ligeiramente diferente, criando o efeito de sincronização no seu cérebro.',
    'settings.title': 'Configurações',
    'settings.profile': 'Perfil',
    'settings.subscription': 'Assinatura',
    'settings.frequency_sessions': 'Frequência e Sessões',
    'settings.default_frequency': 'Frequência Padrão (Hz)',
    'settings.session_duration': 'Duração da Sessão (min)',
    'settings.preferred_breathwork': 'Respiração Preferida',
    'settings.preferences': 'Preferências',
    'settings.dark_mode': 'Modo Escuro',
    'settings.notifications': 'Notificações',
    'settings.auto_play': 'Auto-Reproduzir Som',
    'settings.lunar_info': 'Mostrar Info Lunar',
    'settings.save_profile': 'Salvar Perfil',
    'settings.save_all': 'Salvar Tudo',
    'settings.manage_subscription': 'Gerenciar Assinatura',
    'settings.subscribe_now': 'Assinar Agora',
    'settings.support': 'Suporte',
    'settings.support_desc': 'Precisa de ajuda com NeuroHeal? Entre em contato e responderemos o mais rápido possível.',
    'help.title': 'Ajuda e Suporte',
    'help.subtitle': 'Estamos aqui para ajudar em sua jornada de cura',
    'help.contact': 'Contatar Suporte',
    'help.contact_desc': 'Obtenha ajuda da nossa equipe',
    'help.email_desc': 'Tem uma pergunta, feedback ou problema? Escreva-nos e responderemos rapidamente.',
    'help.quick_links': 'Links Rápidos',
    'help.account_settings': 'Conta e Configurações',
    'help.subscription_billing': 'Assinatura e Cobrança',
    'help.ask_haven': 'Perguntar ao Haven IA',
    'help.faq': 'Perguntas Frequentes',
    'help.response_time': 'Tempo de resposta típico: 24-48 horas',
    'status.active': 'Ativo',
    'status.trial': 'Teste',
    'status.expired': 'Expirado',
    'status.loading': 'Carregando...',
    'status.days_left': 'dias restantes',
  },
};

const LANGUAGE_LABELS = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  zh: '中文',
  pt: 'Português',
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('neuroheal_language') || 'en';
  });

  const changeLanguage = useCallback((lang) => {
    setLanguage(lang);
    localStorage.setItem('neuroheal_language', lang);
  }, []);

  const t = useCallback((key) => {
    return translations[language]?.[key] || translations.en?.[key] || key;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, languages: LANGUAGE_LABELS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
